import { render, staticRenderFns } from "./AdviceText.vue?vue&type=template&id=9b21a628&scoped=true&"
import script from "./AdviceText.vue?vue&type=script&lang=js&"
export * from "./AdviceText.vue?vue&type=script&lang=js&"
import style0 from "./AdviceText.vue?vue&type=style&index=0&id=9b21a628&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b21a628",
  null
  
)

export default component.exports